import React from 'react';

import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import { FEATURES } from 'dpl/shared/constants/features';
import isFeatureEnabled from 'dpl/util/isFeatureEnabled';

import { FOLLOWABLE_TYPES } from '../utils/constants';
import FavoriteButton from './FavoriteButton';

interface IconProps {
  label?: string | null;
  className?: string;
  width?: string;
  height?: string;
}

interface LitterFavoriteButtonProps {
  litter: {
    id: number;
    status: string;
    favoritable: boolean;
  };
  breederProfileId: number;
  analytics: { view: string; [key: string]: any };
  breederFirstName?: string;
  breederProfilePhotoUrl?: string | null;
  className?: string;
  checkedIconProps?: IconProps;
  uncheckedIconProps?: IconProps;
}

export default function LitterFavoriteButton({
  litter,
  breederProfileId,
  analytics,
  breederFirstName,
  breederProfilePhotoUrl,
  className,
  checkedIconProps,
  uncheckedIconProps
}: LitterFavoriteButtonProps) {
  const { isBuyer, isLoggedIn } = useCurrentUser();

  if (!isFeatureEnabled(FEATURES.REL_FAVORITE_LITTERS)) return null;
  if (isLoggedIn === null) return null;
  if (isLoggedIn && !isBuyer) return null;
  if (!litter.favoritable) return null;

  return (
    <FavoriteButton
      className={className}
      followableType={FOLLOWABLE_TYPES.LITTER}
      followableTypeId={litter.id}
      analytics={{
        breeder_profile_id: breederProfileId,
        litter_status: litter.status,
        ...analytics
      }}
      breederFirstName={breederFirstName}
      breederProfilePhotoUrl={breederProfilePhotoUrl ?? undefined}
      checkedIconProps={{
        name: 'fetch-heart-full-breeder',
        ...checkedIconProps
      }}
      uncheckedIconProps={{
        className: 'secondary',
        name: 'fetch-heart',
        ...uncheckedIconProps
      }}
    />
  );
}
